import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, MapPin, Rocket, BadgeCheck, Users, Zap } from 'lucide-react';

const WhyChooseUs = () => {
  const advantages = [
    { icon: Cpu, text: 'AI-First Development Approach' },
    { icon: Zap, text: 'Modern Tech Stack (Next.js, Supabase, Vercel)' },
    { icon: MapPin, text: 'Bangalore-based (same timezone, easy meetings)' },
    { icon: Rocket, text: 'Startup mindset (we move fast)' },
    { icon: BadgeCheck, text: 'Fixed pricing (no hidden costs)' },
    { icon: Users, text: 'Direct founder access (no PM layers)' },
  ];

  return (
    <section className="section-padding bg-white" data-testid="why-choose-us-section">
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#00e5ff] mb-3 block">
            About Us
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#212121] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="why-choose-us-headline"
          >
            Built by AI Experts, For Modern Businesses
          </h2>
        </motion.div>

        {/* Two Column Layout */}
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
          {/* Our Story */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-gradient-to-br from-[#1a237e] to-[#0d1352] rounded-2xl p-6 md:p-8 text-white"
          >
            <h3
              className="text-xl md:text-2xl font-semibold mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Our Story
            </h3>
            <p className="text-white/80 leading-relaxed mb-4">
              Traditional software agencies are broken. ₹50L+ projects. 6-12 month timelines. Endless meetings.
            </p>
            <p className="text-white/80 leading-relaxed mb-4">
              <span className="text-[#00e5ff] font-semibold">We built LitheForce to fix this.</span>
            </p>
            <p className="text-white/80 leading-relaxed mb-4">
              Using AI-first development (Claude, GPT-5, OpenClaw) and modern no-code tools, we deliver custom software{' '}
              <span className="text-[#00e5ff] font-semibold">10x faster at 5x lower cost</span>.
            </p>
            <p className="text-white/80 leading-relaxed">
              No legacy processes. No bloated teams. Just fast, transparent, quality delivery. Based in Bangalore. Serving clients across India.
            </p>
          </motion.div>

          {/* Our Advantage */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-2xl p-6 md:p-8 border border-slate-100 shadow-sm"
          >
            <h3
              className="text-xl md:text-2xl font-semibold text-[#212121] mb-6"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Our Advantage
            </h3>
            <ul className="space-y-4">
              {advantages.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#00e5ff]/10 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-5 h-5 text-[#1a237e]" />
                  </div>
                  <span className="text-[#5a6b8c]">{item.text}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
